import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TablaVerificacionesProduc from "./tablaVerificaciones";
import TablaRelacionFacturasproc from "./tablaRelacionFacturas";
import TablaDeuda1x500 from "./tablaDeuda1x500";
import TablaHistorico1x500 from "./historicoDeuda1x500";

export const EstadodeCuenta = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);

  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
    statusproduccion: "",
    credito: 0.0,
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const blanquear = () => {
    setValues({
      idagente: "",
      nombre: "",
      rif: "",
      direccion: "",
      statusproduccion: "",
      credito: 0.0,
    });
    setActivate(false);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.agente);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>{operacion === 4 ? "Estado de Cuenta." : ""}</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto col-sm-12">
                <legend className="float-none m-0 w-auto">
                  Datos Generales
                </legend>

                <div className="container row m-0">
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Código:</label>{" "}
                      &nbsp; {values ? values.idagente : ""}
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Nombre:</label>{" "}
                      &nbsp; {values ? values.nombre.trim() : ""}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Rif:</label> &nbsp;{" "}
                      {values ? values.rif : ""}
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Dirección:</label>{" "}
                      &nbsp; {values ? values.direccion.trim() : ""}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Estatus:</label>{" "}
                      &nbsp;{" "}
                      {values && values.status1x500 === "51"
                        ? "ACTIVO"
                        : "INACTIVO"}
                    </div>
                  </div>
                </div>
              </fieldset>
              <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-light rounded"
                    style={{ backgroundColor: "#F93154" }}
                    id="ex-with-icons-tab-1"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-1"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-1"
                    aria-selected="true"
                  >
                    <i className="fas fa-money-check fa-fw me-2" />
                    Deudas
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-dark rounded"
                    style={{ backgroundColor: "#25d366" }}
                    id="ex-with-icons-tab-2"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-2"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-2"
                    aria-selected="false"
                  >
                    <i className="fas fa-book-open fa-fw me-2" />
                    Historico de Pagos
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-dark rounded"
                    style={{ backgroundColor: "#55acee" }}
                    id="ex-with-icons-tab-3"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-3"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-3"
                    aria-selected="false"
                  >
                    <i className="fas fa-vote-yea fa-fw me-2" />
                    Relación de Facturas
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-dark rounded"
                    style={{ backgroundColor: "#55c8ff" }}
                    id="ex-with-icons-tab-5"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-5"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-5"
                    aria-selected="false"
                  >
                    <i className="fas fa-check-circle fa-fw me-2" />
                    Verificación
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="ex-with-icons-content">
                <div
                  className="tab-pane fade show active"
                  id="ex-with-icons-tabs-1"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-1"
                >
                  <TablaDeuda1x500
                    tabdeuda={props.tabdeuda}
                    agente={props.agente}
                    credito={values ? values.credito : "0,00"}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="ex-with-icons-tabs-2"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-2"
                >
                  <TablaHistorico1x500 tabpago={props.tabpago} />
                </div>
                <div
                  className="tab-pane fade"
                  id="ex-with-icons-tabs-3"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-3"
                >
                  <TablaRelacionFacturasproc factura={props.factura} />
                </div>
                <div
                  className="tab-pane fade"
                  id="ex-with-icons-tabs-5"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-5"
                >
                  <TablaVerificacionesProduc verific={props.verific} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i> Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/modalEstadodeCuenta.js